module.exports = [
  {
    slug: "/services",
    bgImage: require('../assets/Home/DAIF_Menu.jpg'),
    videoTransitionIn: require('../assets/02_Services/DAIF_Services_In.mp4'),
    videoBgLoop: require('../assets/02_Services/DAIF_Services_Loop.mp4'),
    bgImage2: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/services/1in",
        width: "28%",
        height: "4.5%",
        top: "70%",
        left: "68.4%",
      },
      {
        url: "/services/2in",
        width: "28%",
        height: "4.5%",
        top: "74.6%",
        left: "68.4%",
      },
      {
        url: "/services/3in",
        width: "28%",
        height: "4.5%",
        top: "79.2%",
        left: "68.4%",
      },
      {
        url: "/services/4in",
        width: "28%",
        height: "4.5%",
        top: "83.9%",
        left: "68.4%",
      },
      {
        url: "/services/5in",
        width: "28%",
        height: "4.5%",
        top: "88.5%",
        left: "68.4%",
      },
    ],
  },
  {
    slug: "/servicesb",
    bgImage: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    videoTransitionIn: require('../assets/02_Services/DAIF_Services_Loop.mp4'),
    videoBgLoop: require('../assets/02_Services/DAIF_Services_Loop.mp4'),
    bgImage2: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/services/1in",
        width: "28%",
        height: "4.5%",
        top: "70%",
        left: "68.4%",
      },
      {
        url: "/services/2in",
        width: "28%",
        height: "4.5%",
        top: "74.6%",
        left: "68.4%",
      },
      {
        url: "/services/3in",
        width: "28%",
        height: "4.5%",
        top: "79.2%",
        left: "68.4%",
      },
      {
        url: "/services/4in",
        width: "28%",
        height: "4.5%",
        top: "83.9%",
        left: "68.4%",
      },
      {
        url: "/services/5in",
        width: "28%",
        height: "4.5%",
        top: "88.5%",
        left: "68.4%",
      },
    ],
  },

  {
    slug: "/services/1in",
    bgImage: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    videoTransitionIn: require('../assets/02_Services/DAIF_Services_Screen1_in.mp4'),
    videoTransitionInEnd: require('../assets/02_Services/DAIF_Services_Screen1_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/02_Services/DAIF_Services_Screen1_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/services/1",
  },
  {
    slug: "/services/2in",
    bgImage: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    videoTransitionIn: require('../assets/02_Services/DAIF_Services_Screen2_in.mp4'),
    videoTransitionInEnd: require('../assets/02_Services/DAIF_Services_Screen2_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/02_Services/DAIF_Services_Screen2_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/services/2",
  },
  {
    slug: "/services/3in",
    bgImage: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    videoTransitionIn: require('../assets/02_Services/DAIF_Services_Screen3_in.mp4'),
    videoTransitionInEnd: require('../assets/02_Services/DAIF_Services_Screen3_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/02_Services/DAIF_Services_Screen3_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/services/3",
  },
  {
    slug: "/services/4in",
    bgImage: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    videoTransitionIn: require('../assets/02_Services/DAIF_Services_Screen4_in.mp4'),
    videoTransitionInEnd: require('../assets/02_Services/DAIF_Services_Screen4_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/02_Services/DAIF_Services_Screen4_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/services/4",
  },
  {
    slug: "/services/5in",
    bgImage: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    videoTransitionIn: require('../assets/02_Services/DAIF_Services_Screen5_in.mp4'),
    videoTransitionInEnd: require('../assets/02_Services/DAIF_Services_Screen5_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/02_Services/DAIF_Services_Screen5_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/services/5",
  },

  {
    slug: "/services/1",
    bgImage: require('../assets/02_Services/DAIF_Services_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/02_Services/02_DAIF_Services_01.mp4'),
    videoBgLoop: require('../assets/02_Services/02_DAIF_Services_01_loop.mp4'),
    bgImage2: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/servicesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/services/2",
    bgImage: require('../assets/02_Services/DAIF_Services_Screen2_in-end.jpg'),
    videoTransitionIn: require('../assets/02_Services/02_DAIF_Services_02.mp4'),
    videoBgLoop: require('../assets/02_Services/02_DAIF_Services_02_loop.mp4'),
    bgImage2: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/servicesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/services/3",
    bgImage: require('../assets/02_Services/DAIF_Services_Screen3_in-end.jpg'),
    videoTransitionIn: require('../assets/02_Services/02_DAIF_Services_03.mp4'),
    videoTransitionInEnd: require('../assets/02_Services/02_DAIF_Services_03_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/servicesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/services/4",
    bgImage: require('../assets/02_Services/DAIF_Services_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/02_Services/02_DAIF_Services_04.mp4'),
    videoBgLoop: require('../assets/02_Services/02_DAIF_Services_04_loop.mp4'),
    bgImage2: require('../assets/02_Services/DAIF_Services_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/servicesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/services/5",
    bgImage: require('../assets/02_Services/DAIF_Services_Screen5_in-end.jpg'),
    videoTransitionIn: require('../assets/02_Services/02_DAIF_Services_05.mp4'),
    videoTransitionInEnd: require('../assets/02_Services/02_DAIF_Services_05_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/02_Services/02_DAIF_Services_05_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/servicesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  
]